import { useState, useRef, useEffect } from "react";

import { ThemeProvider, CssBaseline } from "@mui/material";

import Progress from "@/components/progress/progress";

import TabsLayout from "@user/layout/tabs_layout";

import theme from "@user/assets/theme/theme";

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="wrap">
        <TabsLayout />
      </div>
      <Progress />
    </ThemeProvider>
  );
}
